import { Options } from 'vue-class-component';
import {
  ContactType,
  TemperatureType,
} from '@/../client-generator/generated-clients/device-settings';
import ThermoPreferenceComponent from '../ThermoPreferenceComponent';
import { formattedTimeToSeconds, secondsToFormattedTime } from '@/core/utils/utils';

@Options({
  name: 'PreferenceWindowsContact',
  watch: {
    openingContactDelayHeating: function(newValue, oldValue) {
      if (!oldValue) return;
      this.roomObject.openingContactDelayHeating = secondsToFormattedTime(newValue);
    },
    timeoutOpeningHeating: function(newValue, oldValue) {
      if (!oldValue) return;
      this.roomObject.timeoutOpeningHeating = secondsToFormattedTime(newValue);
    },
    closingContactDelayHeating: function(newValue, oldValue) {
      if (!oldValue) return;
      this.roomObject.closingContactDelayHeating = secondsToFormattedTime(newValue);
    },
    timeoutClosingHeating: function(newValue, oldValue) {
      if (!oldValue) return;
      this.roomObject.timeoutClosingHeating = secondsToFormattedTime(newValue);
    },
    openingContactDelayCooling: function(newValue, oldValue) {
      if (!oldValue) return;
      this.roomObject.openingContactDelayCooling = secondsToFormattedTime(newValue);
    },
    timeoutOpeningCooling: function(newValue, oldValue) {
      if (!oldValue) return;
      this.roomObject.timeoutOpeningCooling = secondsToFormattedTime(newValue);
    },
    closingContactDelayCooling: function(newValue, oldValue) {
      if (!oldValue) return;
      this.roomObject.closingContactDelayCooling = secondsToFormattedTime(newValue);
    },
    timeoutClosingCooling: function(newValue, oldValue) {
      if (!oldValue) return;
      this.roomObject.timeoutClosingCooling = secondsToFormattedTime(newValue);
    },
  }
})
export default class PreferenceWindowsContact extends ThermoPreferenceComponent {
  ContactType = ContactType;
  TemperatureType = TemperatureType;

  dataCelsius = { min: 10, max: 30, step: 1 };
  dataFahrenheit = { min: 50, max: 86, step: 1.8 };

  openingContactDelayHeating = 0;
  timeoutOpeningHeating = 0;
  closingContactDelayHeating = 0;
  timeoutClosingHeating = 0;
  openingContactDelayCooling = 0;
  timeoutOpeningCooling = 0;
  closingContactDelayCooling = 0;
  timeoutClosingCooling = 0;

  get openingContactTypeHeatingOptions() {
    return [
      {
        label: this.$t('AppResource.NoAction'),
        value: ContactType.NoAction,
      },
      {
        label: this.$t('AppResource.Protection'),
        value: ContactType.Protection,
      },
      {
        label: this.$t('AppResource.Manual'),
        value: ContactType.Manual,
      },
    ];
  }

  get contactTypeOptions() {
    return [
      {
        label: this.$t('AppResource.NoAction'),
        value: ContactType.NoAction,
      },
      {
        label: this.$t('AppResource.Protection'),
        value: ContactType.Protection,
      },
      {
        label: this.$t('AppResource.Manual'),
        value: ContactType.Manual,
      },
    ];
  }

  get chosenTempParams() {
    if (this.roomObject.temperatureType === TemperatureType.Fahrenheit) {
      return this.dataFahrenheit;
    }
    return this.dataCelsius;
  }

  get tempLabel() {
    if (this.roomObject.temperatureType === TemperatureType.Fahrenheit) {
      return this.$t('AppResource.FahrenheitDegrees');
    }
    return this.$t('AppResource.CelsiusDegrees');
  }

  mounted() {
    if (this.roomObject.openingContactDelayHeating !== '00:00:00') {
      this.openingContactDelayHeating = formattedTimeToSeconds(
        this.roomObject.openingContactDelayHeating as string
      );
    }

    if (this.roomObject.timeoutOpeningHeating !== '00:00:00') {
      this.timeoutOpeningHeating = formattedTimeToSeconds(
        this.roomObject.timeoutOpeningHeating as string
      );
    }

    if (this.roomObject.closingContactDelayHeating !== '00:00:00') {
      this.closingContactDelayHeating = formattedTimeToSeconds(
        this.roomObject.closingContactDelayHeating as string
      );
    }

    if (this.roomObject.timeoutClosingHeating !== '00:00:00') {
      this.timeoutClosingHeating = formattedTimeToSeconds(
        this.roomObject.timeoutClosingHeating as string
      );
    }

    if (this.roomObject.openingContactDelayCooling !== '00:00:00') {
      this.openingContactDelayCooling = formattedTimeToSeconds(
        this.roomObject.openingContactDelayCooling as string
      );
    }

    if (this.roomObject.timeoutOpeningCooling !== '00:00:00') {
      this.timeoutOpeningCooling = formattedTimeToSeconds(
        this.roomObject.timeoutOpeningCooling as string
      );
    }

    if (this.roomObject.closingContactDelayCooling !== '00:00:00') {
      this.closingContactDelayCooling = formattedTimeToSeconds(
        this.roomObject.closingContactDelayCooling as string
      );
    }

    if (this.roomObject.timeoutClosingCooling !== '00:00:00') {
      this.timeoutClosingCooling = formattedTimeToSeconds(
        this.roomObject.timeoutClosingCooling as string
      );
    }
  }
}
